module.exports = __webpack_public_path__ + "media/images/NIHR_logo-7931d1c331e9ce43946789b6a0538a04.svg";